//Rimozione dei layer
const removeOldLayer = (map) => {
  
    map.eachLayer(element => {
      if ( element.options.nome === "position" || element.options.nome === "TripPolyline" || element.options.nome === "stop") {
          try {
              element.removeFrom(map)
          }
          catch(e) {
          }
      }
    });
  }

  export default removeOldLayer